import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Platform } from '@ionic/angular';

import { InitConstant, DialogConstant } from '../../Constant';

import { AuthService } from '../../service/auth.service';
import { EventService } from '../../service/event.service';
import { ApiService } from '../../service/api.service';
import { ToastService } from '../../service/toast.service';
import { DialogService } from '../../service/dialog.service';
import { UploadService } from '../../service/upload.service';

import { PreviewModalPage } from '../preview-modal/preview-modal.page';
import { RenameModalPage } from '../rename-modal/rename-modal.page';
import { CloudselectorModalPage } from '../cloudselector-modal/cloudselector-modal.page';

declare var window;

@Component({
    selector: 'app-filemenu-modal',
    templateUrl: './filemenu-modal.page.html',
    styleUrls: ['./filemenu-modal.page.scss'],
})
export class FilemenuModalPage
{
    private page = null;
    private file: any;
    private is_mobile = false;
    private list_viewtype = 'list-block';
    private filemenu_modal = null;

    constructor(
        private nav: NavController,
        private modalCtrl: ModalController,
        private navParams: NavParams,
        private platform: Platform,
        private auth: AuthService,
        private event: EventService,
        private api: ApiService,
        private toast: ToastService,
        private dialog: DialogService,
        private upload: UploadService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'filemenu-modal', value: null});
        this.page = this.navParams.data.page;
        this.file = this.navParams.data.file;
        this.list_viewtype = this.navParams.data.list_viewtype;
        this.is_mobile = this.platform.is("mobile");
    }

    async folderMove()
    {
        await this.fileMenuClose();
        await this.auth.removeSettings(`${this.page}_search_word::${this.file.id}`);
        this.nav.navigateRoot(`/${this.page}/${this.file.id}`);
    }

    async filePreview()
    {
        await this.fileMenuClose();

        if (!this.auth.empty(this.filemenu_modal)) return;
        this.filemenu_modal = 0;

        this.filemenu_modal = await this.modalCtrl.create({
            component: PreviewModalPage,
            id: 'preview-modal',
            cssClass: 'preview-modal',
            backdropDismiss: false,
            swipeToClose: true,
            mode: 'ios',
            componentProps: { file: this.file }
        });

        this.filemenu_modal.onDidDismiss().then(async(ret) => {
            this.filemenu_modal = null;
        });

        await this.filemenu_modal.present();
    }

    async fileFavorite(favorite_flg)
    {
        await this.fileMenuClose();

        const ret = await this.api.addfavorite(this.file.id, this.file.file_flg, favorite_flg);
        const proc_id = `addfavorite:`+this.file.id;

        if (!this.api.isSuccess(proc_id)) {
            await this.api.setErrorToast(proc_id);
            return;
        }

        if (!this.auth.empty(ret)) {
            this.file.favorite_flg = favorite_flg;

            if (this.page == 'favorite') {
                this.event.page_reload_subject.next(-1);
            }

            if (favorite_flg == 1) {
                this.toast.infoNotification(DialogConstant.FILE_FAVORITE_ADD_SUCCESS);
            } else {
                this.toast.infoNotification(DialogConstant.FILE_FAVORITE_DEL_SUCCESS);
            }
        }
    }

    async fileRename()
    {
        await this.fileMenuClose();

        if (!this.auth.empty(this.filemenu_modal)) return;
        this.filemenu_modal = 0;

        const css = (this.is_mobile ? ' rename-modal-small' : '');

        this.filemenu_modal = await this.modalCtrl.create({
            component: RenameModalPage,
            id: 'rename-modal',
            cssClass: `rename-modal${css}`,
            backdropDismiss: false,
            swipeToClose: true,
            mode: 'ios',
            componentProps: { file: this.file }
        });

        this.filemenu_modal.onDidDismiss().then(async(ret) => {
            if (ret !== null && !this.auth.empty(ret.data)) {
                const data = ret.data;
                const resp = await this.api.rename(this.file.id, this.file.file_flg, (this.auth.empty(this.file.parent_id) ? "" : this.file.parent_id), data.name);

                if (!this.api.isSuccess(`rename:`+this.file.id)) {
                    const err_msg = this.api.getErrorMessage(`rename:`+this.file.id);
                    this.toast.errorNotification(err_msg);
                    return;
                }

                this.event.page_reload_subject.next(-1);
            }

            this.filemenu_modal = null;
        });

        await this.filemenu_modal.present();
    }

    async fileDownload()
    {
        const check = await this.api.getfile(this.file.file_name, (this.auth.empty(this.file.parent_id) ? "" : this.file.parent_id), Date.now(), false, this.file.trash_flg);
        if (this.auth.empty(check)) {
            this.toast.errorNotification(DialogConstant.FILE_DOWNLOAD_ERR);
            return;
        } else if (check.is_storage == 0) {
            this.toast.errorNotification(DialogConstant.FILE_DOWNLOAD_BUSY_ERR);
            return;
        }

        let a = <HTMLAnchorElement>document.createElement('A');
        a.download = this.file.file_name;
        a.href = this.file.url;
        a.target = "_blank";
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async fileMove()
    {
        await this.fileMenuClose();

        if (!this.auth.empty(this.filemenu_modal)) return;
        this.filemenu_modal = 0;

        this.filemenu_modal = await this.modalCtrl.create({
            component: CloudselectorModalPage,
            id: 'cloudselector-modal',
            cssClass: 'cloudselector-modal',
            backdropDismiss: false,
            swipeToClose: true,
            mode: 'ios'
        });

        this.filemenu_modal.onDidDismiss().then(async(modalRet) => {
            if (modalRet !== null && !this.auth.empty(modalRet.data)) {
                const data = modalRet.data;

                if ((this.auth.empty(this.file.parent_id) && this.auth.empty(data.parent_id)) || (this.file.parent_id == data.parent_id)) {
                    this.toast.errorNotification(DialogConstant.FILE_MOVE_SAME_ERR);
                    this.filemenu_modal = null;
                    return;
                 }

                const ret = await this.api.move(this.file.id, this.file.file_flg, data.parent_id);
                const proc_id = `move:`+this.file.id;

                if (!this.api.isSuccess(proc_id)) {
                    await this.api.setErrorToast(proc_id);
                    return;
                }

                if (ret.d_file_caches.length == 0) {
                    this.toast.errorNotification(DialogConstant.NOTFOUND_ERR);
                    return;
                }

                if (this.page == 'file' || this.page == 'favorite') {
                    this.event.page_reload_subject.next(-1);
                }

                const msg = DialogConstant.FILE_MOVE_SUCCESS.replace('{NAME}', this.file.file_name);
                await this.toast.infoNotification(msg);
            }

            this.filemenu_modal = null;
        });

        await this.filemenu_modal.present();
    }

    async fileCopy()
    {
        await this.fileMenuClose();

        if (!this.auth.empty(this.filemenu_modal)) return;
        this.filemenu_modal = 0;

        this.filemenu_modal = await this.modalCtrl.create({
            component: CloudselectorModalPage,
            id: 'cloudselector-modal',
            cssClass: 'cloudselector-modal',
            backdropDismiss: false,
            swipeToClose: true,
            mode: 'ios'
        });

        this.filemenu_modal.onDidDismiss().then(async(modalRet) => {
            if (modalRet !== null && !this.auth.empty(modalRet.data)) {
                let is_refresh = false;
                let new_file_name = this.file.file_name;
                const data = modalRet.data;

                if ((this.auth.empty(this.file.parent_id) && this.auth.empty(data.parent_id)) || (this.file.parent_id == data.parent_id)) {
                    new_file_name = await this.upload.fileRename(new_file_name, data.parent_id);
                    is_refresh = true;
                 }

                const parent_id = (this.auth.empty(this.file.parent_id) ? "" : this.file.parent_id);
                const to_parent_id = (this.auth.empty(data.parent_id) ? "" : data.parent_id);
                const ret = await this.api.copy(this.file.id, parent_id, to_parent_id, new_file_name, 0);
                const proc_id = `copy:`+this.file.id;

                if (!this.api.isSuccess(proc_id)) {
                    this.api.setErrorToast(proc_id);
                    return;
                }

                if (is_refresh === true) {
                    this.event.page_reload_subject.next(-1);
                }

                this.toast.infoNotification(DialogConstant.FILE_COPY_SUCCESS);
            }

            this.filemenu_modal = null;
        });

        await this.filemenu_modal.present();
    }

    async fileDelete()
    {
        await this.fileMenuClose();

        const btn1 = {
            text: DialogConstant.BUTTON_CANCEL,
            role: 'cancel'
        };

        const btn2 = {
            text: DialogConstant.BUTTON_OK,
            handler: async() => {
                const ret = await this.api.addtrash(this.file.id, this.file.file_flg, (this.auth.empty(this.file.parent_id) ? "" : this.file.parent_id));
                const proc_id = `addtrash:`+this.file.id;

                if (!this.api.isSuccess(proc_id)) {
                    this.api.setErrorToast(proc_id);
                    return;
                }

                if (ret.d_file_trashes.length == 0) {
                    this.toast.errorNotification(DialogConstant.NOTFOUND_ERR);
                    return;
                }

                this.event.page_reload_subject.next(-1);

                this.toast.infoNotification(DialogConstant.FILE_TRASH_ADD_SUCCESS);
            }
        };

        const msg = DialogConstant.FILE_TRASH_ADD_COFIRM.replace("{NAME}", this.file.file_name);

        this.dialog.confirm(DialogConstant.CONFIRM_TITLE, msg, [btn1, btn2]);
    }

    async fileMenuClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'filemenu-modal', value: null});
        await new Promise(resolve => setTimeout(resolve, 300));
    }
}
